import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './ForgotPassword.css';
import { useContext } from "react";
import AlertContext from "../../contexts/AlertContext";

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const navigate = useNavigate();
  const { showAlert } = useContext(AlertContext);
  // Ensure axios uses credentials for the request
  axios.defaults.withCredentials = true;

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Submitting email:", email);

    axios.post('https://back.varankal.com/auth/forgot-password', { email }, { headers: { 'Content-Type': 'application/json' }, withCredentials: true })
      .then(res => {
        console.log("Response:", res); // Log the response
        if (res.data.Status === "Success") {
          showAlert('Password reset link sent to your email.');
          navigate('/');
        }
      })
      .catch(err => {
        console.error("Error:", err.response ? err.response.data : err); // Log detailed error
        showAlert('An error occurred. Please try again later.', "error");
      });
  };


  return (
    <div className="forgot-password-page-container">
      <div className="forgot-password-form-wrapper">
        <h2 className="forgot-password-title">Forgot Password</h2>
        <form onSubmit={handleSubmit} className="forgot-password-form">
          <div className="forgot-password-input-container">
            <label className="forgot-password-label">Email:</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}

              required
              className="forgot-password-input-field"
            />
          </div>
          <button type="submit" className="forgot-password-submit-btn">Submit</button>
        </form>
      </div>
    </div>

  );
}

export default ForgotPassword;
